// Default vertical offset for popover positioning relative to trigger
// Negative value allows popover to overlap with a trigger element
// We cannot use CSS variable here, it resolves to string; a Radix component expects number
export const DEFAULT_POPOVER_SIDE_OFFSET = -30;
